<template>
  <div class="weui-search-box">
    <div class="weui-cell weui-cell_active">
      <div class="weui-cell__hd" v-if="label">
        <label for class="weui-label">{{label}}</label>
      </div>
      <div class="weui-cell__bd">
        <input
          :value="value"
          @input="onchange"
          class="weui-input weui-search-box__input"
          :placeholder="placeholder"
          ref="input"
        />
      </div>
    </div>
    <div class="weui-cells weui-search-result" v-if="result && result.length">
      <div
        class="weui-cell weui-cell_active weui-cell_access"
        v-for="(item, index) in result"
        :key="item.id"
        @click="onSelect(index)"
      >
        <div class="weui-cell__bd">
          <p>
            {{item.ve_name}}
            <span class="list-item-status" v-if="item.ve_type">{{item.ve_type}}</span>
          </p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.ve_code}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    placeholder: {
      type: String,
      default: "搜索",
    },
    value: String,
  },
  data() {
    return {
      result: [],
    };
  },
  methods: {
    resetResultList() {
      this.result = [];
    },
    onchange() {
      var me = this,
        val = me.$refs.input.value
      me.$emit("input", val);
      me.$emit("onchange");
      if (val) {
        if (this.$refs.input == document.activeElement) {
          this.search(val);
        }
      } else {
        this.resetResultList();
      }
    },
    search(val) {
      var me = this;
      setTimeout(function () {
        if (!me.searching && val.length > 1) {
          me.searching = true;
          me.$ajax({
            url: "/api/document/vendor/list",
            params: {
              condition: JSON.stringify([
                {"type":"condition","value":"(upper(ve_name) like '%" + val + "%' or upper(ve_uu) like '%" + val + "%')"},
                {"type":"condition","value":"ve_statuscode='ENABLE' and ve_audit_status_code = 'AUDITED'"}
              ]),
              num: 1,
              size: 10
            }
          })
            .then(function (res) {
              me.searching = false;
              me.result = res.data.list
            })
            .catch(function () {
              me.searching = false;
            });
        }
      }, 100);
    },
    onSelect(index) {
      var me = this,
        selected = me.result[index];
      me.$refs.input.blur();
      me.$emit("input", selected.ve_name);
      me.$emit("select", selected);
      me.resetResultList();
    },
  },
};
</script>

<style scoped>
.weui-search-result {
  background-color: #f8f8f8;
  max-height: 300px;
  overflow-y: auto;
}
.weui-search-box {
  position: relative;
}
.weui-search-box:before {
  content: " ";
  position: absolute;
  top: 0;
  left: 32px;
  right: 32px;
  height: 1px;
  color: rgba(0, 0, 0, 0.1);
  color: var(--weui-FG-3);
  z-index: 2;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  border-top: 1px solid var(--weui-FG-3);
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}
.weui-cells {
  background-color: var(--weui-BG-1);
}
</style>